@if (userAgentService.isMobile()) {
  <input
    type="time"
    [disabled]="disableInput()"
    [value]="value() | format: format() || 'TIME.DEFAULT'"
    (change)="setValue(input.value)"
    #input
    [readOnly]="readonly()"
    (blur)="onTouch()"
    placeholder="{{
      placeholder() || '#UI_CORE.COMPONENTS.TIME_INPUT.PLACEHOLDER' | translate
    }}"
    />
}
@if (userAgentService.isDesktop()) {
  <input
    [disabled]="disableInput()"
    [value]="value() | format: format() || 'TIME.DEFAULT'"
    [readOnly]="readonly()"
    (blur)="onTouch()"
    [ngClass]="inputClass()"
    placeholder="{{
      placeholder() || '#UI_CORE.COMPONENTS.TIME_INPUT.PLACEHOLDER' | translate
    }}"
    (change)="setValue(input.value)"
    #input
    />
}
